import angular from 'angular';
import {
  loaderService,
  ssDialogService,
  reportsDataService,
} from 'app/services';
import {
  confirmDialog,
  alerts,
  actionIcon
} from 'app/components/global';

import controller from './bulk-archive-generated-report-instance.controller';
import directive from './bulk-archive-generated-report-instance.directive';

export default angular.module('app.components.reports.generatedReports.reportType.bulkArchiveGeneratedReportInstance', [
    alerts,
    actionIcon,
    confirmDialog,
    loaderService,
    ssDialogService,
    reportsDataService,
  ])
  .directive('bulkArchiveGeneratedReportInstance', directive)
  .controller('BulkArchiveGeneratedReportInstanceController', controller)
  .name;

console.log('aapp.components.reports.generatedReports.reportType.bulkArchiveGeneratedReportInstance created');
